// @/services/ResourceClient.js
import { CandyClient } from "@cabysis/candy-client";
import { getToken } from "@/utilities/storage";
import { BACK_END_URL } from "@/utilities/config";

const resourceOptions = {
  baseUrl: `${BACK_END_URL}/resource`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
  getToken: () => getToken(),
};

export class ResourceClient extends CandyClient {
  constructor() {
    super(resourceOptions);
  }

  async getUploadUrl(mimeType) {
    // 1. Get base URL from your config
    const baseUrl = resourceOptions.baseUrl;

    // 2. Manually construct the unencoded URL
    const unencodedUrl = `${baseUrl}/upload-url?mimeType=${mimeType}`;


    // 3. Make the request with exact URL
    return this.get(
      `/upload-url?mimeType=${mimeType}`,
      {},
      {
        customHeaders: {
          Authorization: `Bearer ${getToken()}`,
          Accept: "application/json",
        },
        skipParamsEncoding: true, // If your HTTP client supports this
      }
    );
  }

  async createResource(resourceData) {
    return this.post("", resourceData, {
      customHeaders: {
        Authorization: `Bearer ${getToken()}`,
        'Content-Type': 'application/json'
      },
    });
  }

  async getResourceById(leccionId, tipo) {
    const url = `/por-leccion/${leccionId}?tipo=${encodeURIComponent(tipo)}`;
    
    return this.get(url, {}, {
      customHeaders: {
        Authorization: `Bearer ${getToken()}`,
        Accept: "application/json",
        'Content-Type': 'application/json'
      },
    });
  }

  async deleteResource(resourceId) {
    const url = `/delete/${resourceId}`;
    return this.delete(url, {}, {
      customHeaders: {
        Authorization: `Bearer ${getToken()}`,
        Accept: "application/json",
      },
    });
  }
  

  
  
}
